import { motion } from 'motion/react';

export default function BottomLineElement({ ...props }) {
  return (
    <motion.svg
      width="345"
      height="72"
      viewBox="0 0 345 72"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g clipPath="url(#clip0_4327_60627)">
        <path
          d="M-165.689 174.579C-177.423 162.415 146.621 0.652283 161.159 0.00182255C175.696 -0.648638 -82.1677 172.635 -65.7467 180.738C-49.3258 188.841 215.958 5.98759 233.443 15.2562C250.931 24.5229 16.7652 193.385 1.0878 179.939C-14.5896 166.489 310.385 14.5084 339.148 4.39863C367.911 -5.70926 286.477 62.9763 185.954 118.691"
          stroke="#1D1A34"
          strokeWidth="1.21333"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_4327_60627">
          <rect width="345" height="72" fill="white" />
        </clipPath>
      </defs>
    </motion.svg>
  );
}
